import React from 'react';
import PropTypes from 'prop-types';

import noop from 'lodash/noop';

import PopoverAnchor from 'common/components/PopoverAnchor';
import FontFamilyPicker from './FontFamilyPicker';
import FontSizePicker from './FontSizePicker';

import './styles.styl';

const BASE_CLASS_NAME = 'FontPickerEditor';
export default class FontPickerEditor extends React.Component {
    static propTypes = {
        fontSizeList: PropTypes.arrayOf(PropTypes.number),
        fontFamilyList: PropTypes.arrayOf(PropTypes.object),
        defaultFontFamily: PropTypes.object,
        onChangeFontFamily: PropTypes.func,
        defaultFontSize: PropTypes.number,
        activeFontSize: PropTypes.number,
        onChangeFontSize: PropTypes.func,
        popoverClassName: PropTypes.string,
        fontFamilyQa: PropTypes.string,
        fontSizeQa: PropTypes.string,
        ariaLabel: PropTypes.string,
    };

    static defaultProps = {
        fontSizeList: [],
        fontFamilyList: [],
        defaultFontFamily: null,
        onChangeFontFamily: noop,
        defaultFontSize: undefined,
        activeFontSize: undefined,
        onChangeFontSize: noop,
        popoverClassName: null,
        fontFamilyQa: '',
        fontSizeQa: '',
        ariaLabel: undefined,
    };

    render() {
        const {
            fontSizeList,
            fontFamilyList,
            defaultFontFamily,
            onChangeFontFamily,
            defaultFontSize,
            activeFontSize,
            onChangeFontSize,
            fontFamilyQa,
            fontSizeQa,
            ariaLabel,
        } = this.props;

        const className = [
            BASE_CLASS_NAME,
            typeof defaultFontFamily !== 'undefined' &&
                typeof defaultFontSize !== 'undefined' &&
                `${BASE_CLASS_NAME}--complete`,
        ]
            .filter(Boolean)
            .join(' ');

        return (
            <div className={className}>
                {defaultFontFamily && (
                    <PopoverAnchor>
                        <FontFamilyPicker
                            fontFamilyList={fontFamilyList}
                            defaultFontFamily={defaultFontFamily}
                            onChangeFontFamily={onChangeFontFamily}
                            popoverClassName={this.props.popoverClassName}
                            qaId={fontFamilyQa}
                            aria-label={ariaLabel && `${ariaLabel} Font Family Picker`}
                        />
                    </PopoverAnchor>
                )}
                {defaultFontSize !== 'undefined' && (
                    <FontSizePicker
                        fontSizeList={fontSizeList}
                        defaultFontSize={defaultFontSize}
                        activeFontSize={activeFontSize}
                        onChangeFontSize={onChangeFontSize}
                        qaId={fontSizeQa}
                        aria-label={ariaLabel && `${ariaLabel} Font Size Picker`}
                    />
                )}
            </div>
        );
    }
}
